var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SaLink',{staticClass:"text-theme-blue whitespace-nowrap cursor-pointer space-x-2",attrs:{"to":_vm.url,"relative":_vm.relative}},[_c('InlineIcon',{staticClass:"hover:underline",attrs:{"icon":"arrow-left","hide-icon":!_vm.showIcon}},[_vm._v(_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }